module.exports = __webpack_public_path__ + "img/img_throw_3@2x.5198108e.png";